import { Component } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { FirestoreService } from '../../../../shared/services/firestore.service';
import { catchError } from 'rxjs/operators';
import { FirebaseError } from '@angular/fire/app/firebase';
import { readUser } from '../../../../shared/interfaces/user';

@Component({
  selector: 'anon-admin-users',
  templateUrl: './admin-users.component.html',
  styleUrls: ['./admin-users.component.scss']
})
export class AdminUsersComponent {
  public users$?: Observable<readUser[]>;
  public error?: FirebaseError;

  constructor(private db: FirestoreService) {
    this.users$ = (this.db.col$(`users`, { idField: 'id' }) as Observable<readUser[]>)
      .pipe(catchError((error: FirebaseError) => {
        console.error(`error getting admin users`, error.message)
        this.error = error;
        return throwError(error);
      }))
  }

}
